import { AppTopBar } from 'components/AppTopBar';

interface Props {
  title?: string;
  subtitle?: string;
  withBackBtn?: boolean;
}

/**
 * Header for account/settings/detail pages. Uses the shared AppTopBar (back arrow + title)
 * so every page in the app wears the same frosted, rounded-bottom bar — without the
 * account avatar, which doesn't belong on pages reached from inside the account sheet.
 */
export const PageHeader = ({ title, subtitle, withBackBtn }: Props) => (
  <AppTopBar
    variant={withBackBtn ? 'back' : 'brand'}
    title={title}
    subtitle={subtitle}
    showAvatar={false}
  />
);
